/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementDeviceDto
 */
export interface TrackItMeasurementDeviceDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementDeviceDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementDeviceDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementDeviceDto
     */
    $type?: TrackItMeasurementDeviceDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementDeviceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementDeviceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementDeviceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementDeviceDtoTypeEnum = typeof TrackItMeasurementDeviceDtoTypeEnum[keyof typeof TrackItMeasurementDeviceDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementDeviceDto interface.
 */
export function instanceOfTrackItMeasurementDeviceDto(value?: unknown): value is TrackItMeasurementDeviceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementDeviceDtoTypeEnum)[0];
}

export function TrackItMeasurementDeviceDtoFromJSON(json: any): TrackItMeasurementDeviceDto {
    return TrackItMeasurementDeviceDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementDeviceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementDeviceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementDeviceDtoToJSON(value?: TrackItMeasurementDeviceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        '$type': value['$type'],
    });
}

